interface HintPanelProps {
  puzzleId: string;
  hints: [string, string, string];
  revealed: number;  // 0–3
  onReveal: () => void;
}

export function HintPanel({ hints, revealed, onReveal }: HintPanelProps) {
  return (
    <div className="escape-hints">
      {hints.slice(0, revealed).map((hint, i) => (
        <div key={i} className="escape-hint">
          <i className="fa-solid fa-lightbulb escape-hint__icon" aria-hidden="true" />
          <p className="escape-hint__text">{hint}</p>
        </div>
      ))}
      {revealed < 3 && (
        <button
          className="escape-btn escape-btn--ghost escape-btn--sm"
          type="button"
          onClick={onReveal}
        >
          <i className="fa-solid fa-lightbulb" aria-hidden="true" />
          {revealed === 0 ? 'Show a hint' : 'Next hint'}
          {revealed > 0 && <span className="escape-hint-count">{revealed}/3</span>}
        </button>
      )}
      {revealed >= 3 && (
        <p className="escape-hint-exhausted">
          <i className="fa-solid fa-circle-check" aria-hidden="true" /> All hints revealed.
        </p>
      )}
    </div>
  );
}
